import { createFileRoute, notFound } from "@tanstack/react-router";

import { AppView } from "@/components/pages/AppView";
import { JsonLd } from "@/components/layout/JsonLd";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";
import { appJsonLd } from "@/lib/schema";

export const Route = createFileRoute("/$locale/app")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/app",
          ...meta[params.locale].app,
          smartBanner: true,
        })
      : {},
  component: AppRoute,
});

function AppRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return (
    <>
      <JsonLd data={appJsonLd(locale)} />
      <AppView locale={locale} />
    </>
  );
}
